export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Columnas disputadas"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reiniciar"])}
}